const getEnvLabel = () => {
  switch (process.env.NEXT_PUBLIC_APP_ENV) {
    case "development":
      return "【開発】" as const;
    case "staging":
      return "【QA】" as const;
    case "production":
      return "" as const;
    case "test":
      return "【開発】" as const;
  }
};

const envLabel = getEnvLabel();

export const eventName = {
  freeFortuneChatBot: "free_fortune_chat_bot",
  freeFortuneChatBotResult: "free_fortune_chat_bot_result",
  chatPurchaseFlow: "chat_purchase_flow",
  lp1: "lp_1",
  subscriptionLP: "subscription_lp",
  freeFortune: "free_fortune",
} as const;

export const eventAction = {
  freeFortuneChatBot: {
    confirmTheme: "confirm_theme",
    confirmMyBirthDay: "confirm_my_birthday",
    confirmAnswer: "confirm_answer",
    confirmBloodType: "confirm_bloodtype",
    confirmPartnerBirthDay: "confirm_partner_birthday",
    confirmName: "confirm_name",
    clickRegistrationButton01: "click_registration_button_01",
    clickRegistrationButton02: "click_registration_button_02",
  },
  freeFortuneChatBotResult: {
    onFocusNameInput: "on_focus_name_input",
    onFocusEmailInput: "on_focus_email_input",
    clickResultButton: "click_result_button",
    subscribeWithSignup: "subscribe_with_signup",
  },
  chatPurchaseFlow: {
    enterProfile: "enter_profile",
    enterKarte: "enter_karte",
    selectPaymentMethod: "select_payment_method",
    confirmPurchase: "confirm_purchase",
  },
  lp1: {
    clickButton: "click_button",
  },
  subscriptionLP: {
    offerButton01: "offerButton01",
    offerButton02: "offerButton02",
    offerButton03: "offerButton03",
    offerButton04: "offerButton04",
    showFreeFortunePopup: "show_free_fortune_popup",
    closeFreeFortunePopup: "close_free_fortune_popup",
    clickFreeFortunePopup: "click_free_fortune_popup",
  },
  freeFortune: {
    tarotButtonClick: "tarot_button_click",
    cvButtonClick: "ResultPage_cv_button_click",
  },
} as const;

interface SendEventArgs {
  eventName: typeof eventName[keyof typeof eventName];
  eventAction: string;
  eventParams?: { [key: string]: string | number };
}

interface UseGaEventReturn {
  sendEvent: (args: SendEventArgs) => void;
}

export const useGaEvent = (): UseGaEventReturn => {
  const sendEvent = ({
    eventName,
    eventAction,
    eventParams,
  }: SendEventArgs) => {
    if (!window.gtag) return;
    window.gtag("event", `${envLabel}${eventName}`, {
      action_name: eventAction,
      ...eventParams,
    });
  };
  return { sendEvent };
};
